import { render } from "./documents-page.vue?vue&type=template&id=56c745de&ts=true"
import script from "./documents-page.ts?vue&type=script&lang=ts"
export * from "./documents-page.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__